import { Calendar } from "@react-shamsi/calendar";
import "@react-shamsi/calendar/dist/index.css";
import "@react-shamsi/calendar/dist/styles.css";
import { DatePicker } from "@react-shamsi/datepicker";
import "@react-shamsi/datepicker/dist/styles.css";
import "@react-shamsi/timepicker/dist/styles.css";
import { useEffect, useMemo, useState } from "react";
import "./App.css";
function App() {
  const getMaxDate = useMemo(() => {
    const d = new Date();
    d.setDate(d.getDate() + 10);
    return d;
  }, []);
  const [demoTheme, setDemoTheme] = useState<any>("light");
  useEffect(() => {
    setInterval(() => {
      setDemoTheme((previousTheme: string) => {
        if (previousTheme === "light") return "dark";
        if (previousTheme === "dark") return "darkRed";
        return "light";
      });
    }, 3000);
  }, []);
  return (
    <div className="flex flex-col items-center min-h-screen">
      <div className="w-full px-4 lg:px-12 py-12 lg:py-24 flex flex-col lg:flex-row space-x-0 lg:space-x-6 space-y-6 lg:space-y-0 items-center justify-center bg-green-600 text-white mb-12">
        <Calendar theme={demoTheme} />
        <h1 className="text-5xl font-bold">React-shamsi</h1>
      </div>
      <h1>Simple Date Picker:</h1>
      <DatePicker />
      <h1 className="pt-12">Dark theme Date Picker:</h1>
      <DatePicker calendarProps={{ theme: "darkRed" }} />
      <h1 className="pt-12">Date picker with min and max dates:</h1>
      <DatePicker
        calendarProps={{
          minDate: new Date(),
          maxDate: getMaxDate,
        }}
      />
      <h1 className="pt-12">Date picker that automatically updates:</h1>
      <DatePicker autoUpdate />
    </div>
  );
}

export default App;
